import React from 'react';
import styles from './Anchor.module.less';
import { useParams } from 'react-router';
import classNames from 'classnames';
import Anchor from '.';

interface AnchorConfig {
  value: string;
  visible: boolean;
  onAnchorClick?: () => void;
}

interface AnchoredComponentProps {
  [key: string]: unknown;
  anchor: AnchorConfig;
}

const customizePagesStyle = [
  'best-practices',
  'customize',
  'reference',
  'upgrade',
  'upgrade-integration',
  'upgrade-options'
];

const withAnchor = (WrappedComponent: React.FC<AnchoredComponentProps>) => {
  const AnchoredComponent = (props: AnchoredComponentProps) => {
    const { anchor = { value: '', visible: false, onAnchorClick: () => {} } } = props;
    const { page } = useParams();

    const anchorClassnames = classNames(styles.anchor_hoc, {
      [styles.integration_page]: page === 'integrate',
      [styles.getstarted_page]: page === 'getstarted',
      [styles.customize_page]: customizePagesStyle.includes(page ?? '')
    });
    return (
      <div className={anchorClassnames} id={anchor.value}>
        <Anchor value={anchor?.value} visible={anchor.visible} onClick={anchor?.onAnchorClick} />
        <WrappedComponent {...props} />
      </div>
    );
  };
  return AnchoredComponent;
};

export default withAnchor;
